import { FC } from 'react';
import Icon, { IconType } from '../Icon';

import { Container, Text } from './styled';

type Props = {
  children: any;
  icon: IconType;
  padding?: boolean;
};

const EmptyState: FC<Props> = ({ children, icon, padding }) => {
  return (
    <Container padding={padding}>
      <Icon type={icon} size="extraLarge" themeType="grey4" />
      <Text>{children}</Text>
    </Container>
  );
};

export default EmptyState;
